"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var playlist_1 = require("../../stores/playlist");
var _kernel_store_types_1 = require("../../types");
var _kernel_container_1 = __importDefault(require("../../../container"));
var playlist_2 = require("../../selectors/playlist");
var player_1 = require("../../selectors/player");
var queueProgressiveCacheTracks_1 = __importDefault(require("../caching/queueProgressiveCacheTracks"));
function updatePlaylist(playlist, switchImmediately) {
    var _this = this;
    var action = function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
        var logger, state, currentTrack, upcomingFirstTrack, playState, newPlaylist;
        return __generator(this, function (_a) {
            logger = _kernel_container_1.default.get("LOGGING").getLogger("@kernel/updatePlaylist");
            state = getState();
            currentTrack = (0, playlist_2.selectCurrentPlaylistItem)(state);
            upcomingFirstTrack = playlist[0];
            playState = (0, player_1.selectCurrentPlayState)(state);
            logger.info("Updating playlist", {
                curr: currentTrack,
                newCurr: playlist[0],
            });
            if (playState === _kernel_store_types_1.EPlayState.PLAY &&
                currentTrack &&
                currentTrack.rotationId !== upcomingFirstTrack.rotationId &&
                !switchImmediately) {
                logger.debug("updating playlist, in playing state");
                newPlaylist = __spreadArray([currentTrack], __read(playlist), false);
            }
            else {
                logger.debug("replacing playlists");
                newPlaylist = playlist;
            }
            logger.info("Playlist update, updating current track", {
                curr: currentTrack,
                new: newPlaylist[0],
                switchImmediately: switchImmediately,
            });
            dispatch((0, playlist_1.updatePlaylist)(newPlaylist));
            dispatch((0, queueProgressiveCacheTracks_1.default)());
            dispatch({
                type: updatePlaylist.type,
            });
            return [2];
        });
    }); };
    action.type = updatePlaylist.type;
    return action;
}
updatePlaylist.type = "updatePlaylist";
exports.default = updatePlaylist;
//# sourceMappingURL=updatePlaylist.js.map